import React, { FC } from 'react';
import { Box, Button, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useTranslation } from 'react-i18next';

type WeekNavigationProps = {
    onPrev: () => void;
    onNext: () => void;
    onToday: () => void;
    isPrevDisabled: boolean;
};

const WeekNavigation: FC<WeekNavigationProps> = ({ onPrev, onNext, onToday, isPrevDisabled }) => {
    const { t: translate } = useTranslation(['production-dashboard']);

    return (
        <Box display="flex" alignItems="center" gap={1} mb={1}>
            <IconButton onClick={onPrev} disabled={isPrevDisabled} size="small">
                <ArrowBackIcon />
            </IconButton>
            <Button size="small" onClick={onToday}>
                {translate('production-dashboard:TODAY')}
            </Button>
            <IconButton onClick={onNext} size="small">
                <ArrowForwardIcon />
            </IconButton>
        </Box>
    );
};

export default WeekNavigation;
